/**
 * @Author proudlx
 * @Description 登录请求接口路径
 */
/** 登录 */
export const POST_LOGIN_MAIN = "/api/login/main";
export const POST_LOGIN_MAIN_V2 = "/api/login/main/v2";
export const POST_LOGIN_WEB_ACCOUNT_INFO= "/api/login/web_account_info";
export const POST_STUDENT_USERINFO = "/api/student/byUser";
export const POST_LOGOUT = "/api/systemLogout";
// 游客登录
export const POST_LOGIN_VISITOR = "/api/login/visitor";
// 游客升级
export const POST_LOGIN_VISITOR_UPGRADE = "/api/student/visitorUpgrade";

// 首页数据
export const POST_HOME_MARKET_DATA = "/api/home/marketData";

// 飞书认证
export const POST_LOGIN_FEISHU_AUTH = "/api/login/main/feishuAuth";